import { render, staticRenderFns } from "./LegendNearMatch.vue?vue&type=template&id=d1bce11a&scoped=true&"
import script from "./LegendNearMatch.vue?vue&type=script&lang=js&"
export * from "./LegendNearMatch.vue?vue&type=script&lang=js&"
import style0 from "./LegendNearMatch.vue?vue&type=style&index=0&id=d1bce11a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bce11a",
  null
  
)

export default component.exports